<template>
  <div class="document-list-skeleton">
    <div class="skeleton-section pb-4" v-for="i in 4" :key="i">
      <div class="skeleton-header">
        <div class="skeleton-button"></div>
        <div class="skeleton-text skeleton-text--title"></div>
      </div>
      <div class="skeleton-items pl-5 pt-2">
        <div class="skeleton-item" v-for="j in 2" :key="j">
          <div class="skeleton-bullet"></div>
          <div class="skeleton-text skeleton-text--label"></div>
          <div class="skeleton-text skeleton-text--filename"></div>
          <div class="skeleton-text skeleton-text--date"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'document-list-skeleton',
};
</script>

<style lang="sass" scoped>
@keyframes shimmer
  0%
    background-position: -200px 0
  100%
    background-position: 200px 0

.skeleton
  &-section
    margin-bottom: 8px

  &-header
    display: flex
    align-items: center
    padding: 8px 0

  &-button
    width: 32px
    height: 32px
    border-radius: 50%
    margin-right: 12px
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)
    background-size: 400px 100%
    animation: shimmer 1.5s infinite

  &-text
    height: 16px
    border-radius: 4px
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)
    background-size: 400px 100%
    animation: shimmer 1.5s infinite

    &--title
      width: 120px

    &--label
      width: 100px
      flex-shrink: 0

    &--filename
      width: 180px
      margin-left: 12px

    &--date
      width: 80px
      margin-left: 12px

  &-items
    display: flex
    flex-direction: column
    gap: 8px

  &-item
    display: flex
    align-items: center
    padding: 4px 0

  &-bullet
    width: 8px
    height: 8px
    border-radius: 50%
    margin-right: 8px
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)
    background-size: 400px 100%
    animation: shimmer 1.5s infinite
</style>
